<template>
    <CRow>
        <CCol>
            <div style="width:100%; height: 80vh;">
                <ejs-grid ref='grid'
                          :dataSource='data'
                          :allowFiltering='true'
                          :allowPaging='true'
                          :allowResizing='true'
                          :allowReordering='true'
                          :allowSorting='true'
                          :toolbar='toolbar'
                          :pageSettings='pageSettings'
                          :filterSettings='filterOptions'
                          :toolbarClick='toolbarClick'
                          :allowExcelExport='true'
                          :excelExportComplete='excelExportComplete'
                          :query='query'
                          :actionBegin='actionBegin'
                          :actionComplete='actionComplete'
                          :actionFailure='actionFailure'
                          :enablePersistence="true"
                          :showColumnChooser='true'
                          :allowTextWrap='true'
                          :textWrapSettings='textOption'
                          :recordDoubleClick="recordDoubleClick" width="100%" height="100%" :dataBound='onGridDataBound'>
                    <e-columns>
                        <e-column field='clientId' headerText='Id' :isPrimaryKey='true' width=50 :visible='true' type="number"></e-column>
                        <e-column field='clientName' headerText='Name' :template='cTemplate' width=220 type="string"></e-column>
                        <e-column field='consultant' headerText='Consultant' width=110 type="string"></e-column>
                        <e-column field='clientCoordinatorName' headerText='Coordinator' width=120 type="string"></e-column>
                        <e-column field='status' headerText='Status' width=80 type="string"></e-column>
                        <e-column field='fiscalMonthName' headerText='Fiscal Year - End Month' width=150 type="string"></e-column>
                        <e-column field='riskManager' headerText='Risk Manager' width=130 type="string"></e-column>
                        <e-column field='companies' headerText='Companies' width=120 type="string" :template="'companyTemplate'">
                            <template v-slot:companyTemplate={data}>
                                <div class="text-center">
                                    <span v-b-tooltip.hover
                                          :title="data.companiesToolTip">{{data.companies}}</span>
                                </div>
                            </template>

                        </e-column>
                        <e-column field='companiesToolTip' headerText='Companies' :visible='false' :showInColumnChooser='false' width=120 type="string"></e-column>
                        <e-column field='states' headerText='Countries' width=120 type="string" :template="'stateTemplate'">
                            <template v-slot:stateTemplate={data}>
                                <div class="text-center">
                                    <span v-b-tooltip.hover
                                          :title="data.statesToolTip">{{data.states}}</span>
                                </div>
                            </template>
                        </e-column>
                        <e-column field='statesToolTip' headerText='Countries' :visible='false' :showInColumnChooser='false' width=120 type="string"></e-column>
                    </e-columns>
                </ejs-grid>

            </div>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, ColumnChooser } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import gridOptions from '../common/gridOptions'
    import SyncHelper from '../common/syncfusion'
    import apis from '../common/network'
    import router from '../router/index';
    import ClientColumnTemplate from '@/views/helperTemplates/ClientColumnTemplate.vue'
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';


    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    let DialogConfirmDeleteClient = undefined;

    export default {
        name: 'Clients',
        created() {
            //apis.protectedApi(`client/getClientsCount`).then(cc => {
            //    if (cc.data.clients.length == 1) {
            //        router.push({ name: "ClientReports", params: { clientId: cc.data.clients[0].clientId } });
            //    }

            //});

        },
        data() {
            return {
                data: SyncHelper.getDataManager("client"),
                cTemplate: function () {
                    return {
                        template: {
                            extends: ClientColumnTemplate
                        }
                    }
                },
                pageSettings: gridOptions.pageSettings,
                toolbar: [{ text: 'Add', tooltipText: 'Add', prefixIcon: 'e-add', id: 'AddClient' },
                { text: 'Edit', tooltipText: 'Edit', prefixIcon: 'e-edit', id: 'EditClient' },
                { text: 'Delete', tooltipText: 'Delete', prefixIcon: 'e-delete', id: 'DeleteClient' },
                    'ExcelExport', 'ColumnChooser'],
                filterOptions: gridOptions.filterSettings,
                textOption: { wrapMode: 'Content' },
            }
        },
        methods: {
            toolbarClick(args) {
                if (args.item.id === 'AddClient') {
                    this.$router.push({ name: "Client" });
                }
                if (args.item.id === 'EditClient') {
                    let selectedClient = this.$refs.grid.getSelectedRecords();
                    if (selectedClient.length > 0) {
                        this.$router.push({ name: "Client", params: { clientId: selectedClient[0].clientId } });
                    } else {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: "Please, choose a client first",
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    }
                }
                if (args.item.id === 'DeleteClient') {
                    let selectedClient = this.$refs.grid.getSelectedRecords();
                    if (selectedClient) {
                        DialogConfirmDeleteClient = DialogUtility.confirm({
                            title: 'Confirm Delete',
                            content: "Are you sure you want to delete client '" + selectedClient[0].clientName + "'?",
                            position: { X: 700, Y: 200 },
                            okButton: { text: 'OK', click: this.confirmDeleteClient },
                            cancelButton: { text: 'Cancel', click: this.cancelDeleteClient },
                            open: () => {
                                this.$refs.focusElement.focus();
                            },
                            showCloseIcon: true,
                            closeOnEscape: true,
                        });

                    }
                }
                if (args.item.id.indexOf("excelexport") !== -1) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].field == "companies")
                            this.$refs.grid.getColumns()[i].visible = false;

                        if (this.$refs.grid.getColumns()[i].field == "states")
                            this.$refs.grid.getColumns()[i].visible = false;

                        if (this.$refs.grid.getColumns()[i].field == "companiesToolTip")
                            this.$refs.grid.getColumns()[i].visible = true;

                        if (this.$refs.grid.getColumns()[i].field == "statesToolTip")
                            this.$refs.grid.getColumns()[i].visible = true;

                    }
                    //this.$refs.grid.getColumns()[7].visible = false;
                    //this.$refs.grid.getColumns()[8].visible = true;
                    //this.$refs.grid.getColumns()[9].visible = false;
                    //this.$refs.grid.getColumns()[10].visible = true;

                    gridOptions.excelExport(args, "Clients.xlsx", this.$refs);
                    setTimeout(() => {
                        for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                            if (this.$refs.grid.getColumns()[i].field == "companies")
                                this.$refs.grid.getColumns()[i].visible = true;

                            if (this.$refs.grid.getColumns()[i].field == "states")
                                this.$refs.grid.getColumns()[i].visible = true;

                            if (this.$refs.grid.getColumns()[i].field == "companiesToolTip")
                                this.$refs.grid.getColumns()[i].visible = false;

                            if (this.$refs.grid.getColumns()[i].field == "statesToolTip")
                                this.$refs.grid.getColumns()[i].visible = false;

                        }
                    }, 1000)
                }
            },

            confirmDeleteClient: function () {
                let selectedClient = this.$refs.grid.getSelectedRecords();
                apis.protectedApi.delete(`client/${selectedClient[0].clientId}`)
                    .then(response => {
                        this.$refs.grid.refresh()
                        let message = { title: 'Success!', content: 'Client is deleted successfully', cssClass: 'e-toast-success' };
                        this.$root.$emit('showToast', message);
                    }).catch(e => {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: e.response.data.message,
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    });
                DialogConfirmDeleteClient.hide();
            },

            cancelDeleteClient: function () {
                DialogConfirmDeleteClient.hide();
            },

            recordDoubleClick: function (e) {
                this.$router.push({ name: "Client", params: { clientId: e.rowData.clientId } });
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            setToolbarVisibility: function () {
                if (!this.$store.state.permissions["Permissions.Client.Create"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['AddClient'], false);
                }
                if (!this.$store.state.permissions["Permissions.Client.Delete"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['DeleteClient'], false);
                }
                if (!this.$store.state.permissions["Permissions.Client.Update"]) {
                    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['EditClient'], false);
                }
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);
                //showSpinner(document.getElementById('mainSpinner'));


                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));
                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                this.$refs.grid.hideSpinner();
            },
            actionFailure(args) {
                gridOptions.actionFailure(args, this.$refs);

                hideSpinner(document.getElementById('mainSpinner'));
            },
            onGridDataBound(args) {
                hideSpinner(document.getElementById('mainSpinner'));
                //this.$refs.grid.autoFitColumns();
            },

        },
        computed: {
            query: function () {
                return new Query().addParams("userId", this.$store.state.loggedInUserId);
            }
        },
        mounted() {
            this.setToolbarVisibility();
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
            //showSpinner(document.getElementById('mainSpinner'));
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, ColumnChooser]
        }
    }
</script>

<style scoped>
</style>